import { axios } from "@/client/libs/axios";

type CurrentSession = {
  access_token: string;
  refresh_token: string;
};

type Tokens = {
  token0: string;
  token1: string;
};

export const getUser = async () => {
  try {
    const response = await axios.get("/user/me");

    return response.data;
  } catch {
    return null;
  }
};

export const getSession = async () => {
  try {
    const response = await axios.get("/user/get-session");

    return response.data;
  } catch {
    return null;
  }
};

export const getClaims = async () => {
  try {
    const response = await axios.get("/user/claims");
    return response.data;
  } catch {
    return null;
  }
};

/**
 * @deprecated Use getClaims() instead for better performance.
 * This function is kept for backward compatibility but will be removed in a future version.
 */
export const setSession = async (currentSession: CurrentSession) => {
  try {
    currentSession.access_token = document.cookie.split("sb-access-token=")[1].split(";")[0];
    currentSession.refresh_token = document.cookie.split("sb-refresh-token=")[1].split(";")[0];

    const response = await axios.post("/user/set-session", currentSession);

    return { data: response.data };
  } catch {
    return null;
  }
};

export const parseTokens = (tokens: Tokens) => {
  try {
    tokens.token0 = document.cookie.split("sb-qiilhzulchhvmptaayfz-auth-token.0=")[1].split(";")[0];
    tokens.token1 = document.cookie.split("sb-qiilhzulchhvmptaayfz-auth-token.1=")[1].split(";")[0];

    const response = axios.post("/user/read-cookies", tokens);

    return { data: response };
  } catch {
    return null;
  }
};
